
import productsData from '@/db/products.json'

export default {
  name: 'TechSpecs',
  props: {
    image: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
    },
  },
  data() {
    return {
      techSpecsData: null,
    }
  },
  created() {
    // products.json'dan TechSpecs verilerini al
    this.techSpecsData = productsData[1].sections[7]
  },
}
